import { useEffect, useState } from "react";
import { IndianRupee, ShoppingBag, Users, Package, MapPin } from "lucide-react";
import api from "@/lib/api";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)); }, []);
  const cards = [
    { label: "Revenue", value: stats ? `₹${stats.revenue.toLocaleString("en-IN")}` : "—", icon: <IndianRupee className="w-5 h-5" /> },
    { label: "Orders", value: stats?.orders ?? "—", icon: <ShoppingBag className="w-5 h-5" /> },
    { label: "Customers", value: stats?.customers ?? "—", icon: <Users className="w-5 h-5" /> },
    { label: "Products", value: stats?.products ?? "—", icon: <Package className="w-5 h-5" /> },
    { label: "Pincodes", value: stats?.pincodes ?? "—", icon: <MapPin className="w-5 h-5" /> },
  ];
  return (
    <div>
      <div className="overline">Overview</div>
      <h1 className="font-display text-3xl mt-1">Dashboard</h1>
      <div className="mt-6 grid grid-cols-2 md:grid-cols-5 gap-4" data-testid="admin-stats">
        {cards.map((c) => (
          <div key={c.label} className="admin-card p-5">
            <div className="text-[#6C665F]">{c.icon}</div>
            <div className="mt-3 text-2xl font-semibold">{c.value}</div>
            <div className="text-xs uppercase tracking-widest text-[#6C665F] mt-1">{c.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
